import { createSlice } from "@reduxjs/toolkit"

import { assignUserRole } from "../api/api"


const initialState={
   loading:false,
   error:{}, 
   response: null

}

const assignUserRoleSlice= createSlice({
    name:'deactivateUser',
     initialState,

     reducers:{

     },

     extraReducers: (builder)=>{
        builder.addCase( assignUserRole.pending, (state)=>{
            state.loading = true
            state.error={}
            state.response =null

        })

        builder.addCase( assignUserRole.rejected, (state, action)=>{
            state.loading=false
            state.error= action.payload
            state.response=null
        }

        )
        builder.addCase( assignUserRole.fulfilled, (state, action)=>{
            state.loading=false
            state.error={}
            state.response= action.payload
        }
            )


     }

})

export default assignUserRoleSlice.reducer